import { Component, ElementRef, OnInit, Renderer2 } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import e from 'express';
import { ApiCallService } from 'src/app/core/services/api-call-service';
import { SnackbarCollection } from 'src/app/core/services/snackbar.service';
import { ConfirmationDialogBoxComponent } from 'src/app/shared/components/dialog-box';
import { TranslateDynamicText } from 'src/app/shared/pipes/dynamic-translation.pipe';

type ledger = {
  id: number,
  ledgerName: string;
  expiryDays: number;
  isNeverExpiry: boolean;
  priority: number;
  topicName: string;
  topicId: number;
  defaultCreation: false,
  status: 'ACTIVE',
  isDeleted: boolean;
}

type topic = {
  id: number;
  topicName: string;
  isDeleted: boolean;
}

@Component({
  selector: 'app-wallet-config-create',
  templateUrl: './wallet-config-create.component.html',
  styleUrls: ['./wallet-config-create.component.css']
})
export class WalletConfigCreateComponent implements OnInit {

  constructor(
    private _router: Router,
    private dialog: MatDialog,
    private _apicall: ApiCallService,
    private _snackBar: SnackbarCollection,
    private _i18nDynamicTranslate: TranslateDynamicText,
    private elRef: ElementRef,
    private renderer: Renderer2
  ) { }

  ngOnInit(): void {
    this.getLedgerAndTopicList();
  }

  isDataLoading = false;
  getLedgerAndTopicList() {
    this.isDataLoading = true;
    this._apicall.getLedgerAndTopicList().subscribe(
      response => {
        this.isDataLoading = false;
        this.topicList = response["body"].topicList ?? [];
        this.ledgerList = response["body"].ledgerList ?? [];
        if(this.ledgerList.length == 0) {
          this.addLedger();
        } else {
          this.ledgerList.forEach(ledger=>{
            if(ledger.expiryDays == null) {
              ledger.isNeverExpiry = true;
            }
          });
        }
      },
      error => {
        this.isDataLoading = false;
        this._snackBar.openSnackBar("Failed to fetch config: "+error.error.body, 2000);
      }
    );
  }

  getNotAllowedLedgerConfig() {
    this.isDataLoading = true;
    this._apicall.getNotAllowedLedgerConfig().subscribe(
      response => {
        this.isDataLoading = false;
        this.notAllowedLedgerConfig = response["body"];
      },
      error => {
        this.isDataLoading = false;
        this._snackBar.openSnackBar("Failed to fetch config: "+error.error.body, 2000);
      }
    );
  }

  getNotDeletedLedgerList() {
    return this.ledgerList.filter(ledger => !ledger.isDeleted);
  }
  getNotDeletedTopicList() {
    return this.topicList.filter(topic => !topic.isDeleted);
  }

  checkAndAddTopicToLedger(ledger) {
    let topic = this.topicList.find(topic => topic.topicName == ledger.topicName);
    if(!topic.id) {
      ledger.topicName = topic.topicName;
    } else {
      ledger.topicId = topic.id;
      ledger.topicName = topic.topicName;
    }
  }
  

  ledgerList: ledger[] = [];
  addLedger() {
    this.ledgerList.push(
      {
        id:null,
        ledgerName: '', 
        expiryDays: null,
        isNeverExpiry: true, 
        priority: this.getNextPrioritRank(), 
        topicName:null, 
        defaultCreation: false, 
        status: 'ACTIVE',
        isDeleted:false,
        topicId: null
      });
    this.scrollToNewLedger((this.ledgerList.length)-1);
  }

  tempTopic:topic = {
    id: null,
    topicName: '',
    isDeleted: false,
  }
  isTopicCreationUiVisible = false;
  topicList: topic[] = [];
  showTopicCreationUi(toShow) {
    this.isTopicCreationUiVisible = toShow;
    if(!toShow) {
      this.tempTopic = {
        id: null,
        topicName: '',
        isDeleted: false,
      };
    }
  }

  showTopicNameError = false;
  addTopic() {
    this.tempTopic.topicName = this.tempTopic.topicName.trim();
    if(this.topicList.some(topic=>!topic.isDeleted && topic.topicName == this.tempTopic.topicName)) {
      this.showTopicNameError = true;
      return;
    }
    this.topicList.push(this.tempTopic);
    this.tempTopic = {
      id: null,
      topicName: '',
      isDeleted: false,
    };
    this.isTopicCreationUiVisible = false;
  }

  getRankNumberArray(): number[] {
    return this.getNotDeletedLedgerList()?.length>0?Array.from({ length: this.getNotDeletedLedgerList().length }, (_, i) => i + 1):[1];
  }

  getNextPrioritRank() {
    return this.getNotDeletedLedgerList()?.length>0?this.getNotDeletedLedgerList().length+1:1;
  }

  deleteLedger(ledgerName) {
    const dialogref = this.dialog.open(
      ConfirmationDialogBoxComponent,
      {
        panelClass: "no-padding-dialog-popup",
        width: "280px",
        data: {
          subject: `DELETE ${ledgerName}`,
          message: `Are you sure you want to delete ${ledgerName}?,This will reset the priority of all the ledgers`,
          cancelButtonText: this._i18nDynamicTranslate.transform("Cancel", ['POS_PAGE']),
          successButtonText: this._i18nDynamicTranslate.transform("Delete", ['POS_PAGE']),
        }
      }
    );
    dialogref.afterClosed().subscribe((result) => {
      let index = this.ledgerList.findIndex(ledger => ledger.ledgerName == ledgerName);
      if(this.ledgerList[index].id) {
        if(this.ledgerList[index].isDeleted == false)  {
          this.ledgerList[index].isDeleted = true;
        }
      } else {
        this.ledgerList.splice(index,1);
      }
      //reset all ledger priorities
      this.ledgerList.forEach(ledger=>ledger.priority = null);
    });
  }

  deleteTopic(topicName) {
    const dialogref = this.dialog.open(ConfirmationDialogBoxComponent,
      {
        panelClass: "no-padding-dialog-popup",
        width: "280px",
        data: {
          subject: `DELETE ${topicName}`,
          message: `Are you sure you want to delete ${topicName}? All ledgers tagged with this topic will be untagged.`,
          cancelButtonText: this._i18nDynamicTranslate.transform("Cancel", ['POS_PAGE']),
          successButtonText: this._i18nDynamicTranslate.transform("Delete", ['POS_PAGE']),
        }
      }
    );
    dialogref.afterClosed().subscribe((result) => {
      if(result) {
        const index = this.topicList.findIndex(topic => topic.topicName == topicName);
        if(this.topicList[index].id) {
          if(this.topicList[index].isDeleted == false)  {
            this.topicList[index].isDeleted = true;
          }
        } else {
          this.topicList.splice(index,1);
        }
      }
      //untag  all ledgers with this topic
      this.ledgerList.forEach(ledger => {
        if(ledger.topicName == topicName) {
          ledger.topicName = null;
          ledger.topicId = null;
        }
      });
    });
  }

  discard() {
    const dialogref = this.dialog.open(ConfirmationDialogBoxComponent,
      {
        panelClass: "no-padding-dialog-popup",
        width: "280px",
        data: {
          subject: `Discard changes`,
          message: `Are you sure you want to discard changes?`,
          cancelButtonText: this._i18nDynamicTranslate.transform("Cancel", ['POS_PAGE']),
          successButtonText: this._i18nDynamicTranslate.transform("Discard", ['POS_PAGE']),
        }
      }
    );
    dialogref.afterClosed().subscribe((result) => {
      if(result) {
        this.navigateToWallet();
      }
    });
  }

  private resetErrorState() {
    const inputFields = document.querySelectorAll('.error-input');
      // Remove error class from all input fields
      inputFields.forEach(inputField => {
        inputField.classList.remove('error-input');
      });
      const popovers = document.querySelectorAll('.error-popover');
      // Remove the popover if found
      popovers.forEach(popover => {
        popover.remove();
      });
  }

  private setErrorState(inputId: string,message) {
    // Add error class to the specified input field
    const inputField = this.elRef.nativeElement.querySelector(`#${inputId}`);
    if (inputField) {
      inputField.classList.add('error-input');
      this.addPopover(inputField,message);
    }
  }

  addPopover(inputElement: HTMLElement,message: string) {
    const popover = this.renderer.createElement('div');
    this.renderer.addClass(popover, 'error-popover'); 
    this.renderer.setProperty(popover, 'innerHTML', message); // Set popover content
    // Calculate the right position
    const containerWidth = inputElement.getBoundingClientRect().width;
    // const containerHeight = inputElement.getBoundingClientRect().height;
    // const rightPosition = window.innerWidth - containerRight + popoverWidth; // Calculate the right positio
    this.renderer.setStyle(popover, 'left', `${(containerWidth/2)-40}px`); // Set the right position
    // this.renderer.setStyle(popover, 'top', `${containerHeight-70}px`);
    this.renderer.appendChild(inputElement, popover);
  }

  scrollToErrorField() {
    setTimeout(() => {
      const errorField = document.querySelector('.error-input');
      if (errorField) {
          errorField.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    }, 250);
  }

  scrollToNewLedger(index) {
    setTimeout(() => {
      const errorField = document.querySelector(`#ledgerName${index}`);
      if (errorField) {
          errorField.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    }, 250);
  }

  isConfigValid() {
    let hasError = false;
    let ledgerNameSet = new Set();
    let prioritySet = new Set();
    for(let i=0; i<this.ledgerList.length; i++) {
      if(this.ledgerList[i].isDeleted) {
        continue;
      }
      this.ledgerList[i].ledgerName = this.ledgerList[i].ledgerName?.trim();
      if(!this.ledgerList[i].ledgerName) {
        this.setErrorState('ledgerName'+i,'Please enter valid name');
        this.scrollToErrorField();
        hasError = true;
      }
      if(this.ledgerList[i].ledgerName.length<2) {
        this.setErrorState('ledgerName'+i,'Name cannot be less than 2 characters');
        this.scrollToErrorField();
        hasError = true;
      }
      if (ledgerNameSet.has(this.ledgerList[i].ledgerName)) {
        this.setErrorState('ledgerName'+i,'Duplicate ledger name not allowed');
        this.scrollToErrorField();
        hasError = true;
      } else {
        ledgerNameSet.add(this.ledgerList[i].ledgerName);
      }
      if(!this.ledgerList[i].isNeverExpiry && !this.ledgerList[i].expiryDays) {
        this.setErrorState('expiryDays'+i,'Please enter valid expiry days');
        this.scrollToErrorField();
        hasError = true;
      }
      if(!this.ledgerList[i].priority) {
        this.setErrorState('priority'+i,'Please select a Priority rank');
        this.scrollToErrorField();
        hasError = true
      } else {
        if(prioritySet.has(this.ledgerList[i].priority)) {
          this.setErrorState('priority'+i,'Duplicate Priority rank');
          this.scrollToErrorField();
          hasError = true
        } else {
          prioritySet.add(this.ledgerList[i].priority);
        }
      }
    }
    if(hasError) {
      return false;
    }
    return true;
  }

  selectedTabIndex = 0;
  saveLedgerAndTopicConfig(goToNextTab?) {
    this.resetErrorState();
    if(this.isConfigValid()) {
      let requestData = {
        ledgerList: this.ledgerList,
        topicList: this.topicList
      }
      this._apicall.saveWalletLedgersAndTopics(requestData).subscribe(
        response => {
          this._snackBar.openSnackBar("Successfully saved Ledgers and Topics", 2000);
          if(goToNextTab) {
            this.selectedTabIndex = 1;
            this.getNotAllowedLedgerConfig();
          } else {
            this.navigateToWallet();
          }
        },
        error => {
          this._snackBar.openSnackBar("Failed to save: "+error.error.body, 2000);
        }
      );
    }
  }

  notAllowedLedgerConfig = {
    "couponCode": {
        "notAllowedLedgers": []
    },
    "thomcoinsEarning": {
        "notAllowedLedgers": []
    },
    "thomcoinsRedemption": {
        "notAllowedLedgers": []
    },
    "delivery": {
        "notAllowedLedgers": []
    },
    // "cashback": {
    //     "notAllowedLedgers": []
    // },
    // "loyaltyPrograms": {
    //     "notAllowedLedgers": []
    // }
  };
  saveNotAllowedLedgerConfig(goBack?) {
    this._apicall.saveNotAllowedLedgerConfig(this.notAllowedLedgerConfig).subscribe(
      response=> {
        this._snackBar.openSnackBar("Successfully saved configuration", 2000);
        if(goBack) {
          this.selectedTabIndex = 0;
          this.getLedgerAndTopicList();
          this.selectedTabIndex = 0;
        } else {
          this.navigateToWallet();
        }
      },
      error=> {
        this._snackBar.openSnackBar('Error saving :'+error.error.body,2000);
      }
    );
  }

  saveAndExitBasedOnTab() {
    if(this.selectedTabIndex == 0) {
      this.saveLedgerAndTopicConfig();
    } else {
      this.saveNotAllowedLedgerConfig();
    }
  }

  navigateToWallet() {
    this._router.navigate(['/app/wallet']);
  }
  
  numberInputHandler(event: KeyboardEvent,maxLength,inputType?) {

    const inputValue = (event.target as HTMLInputElement).value;
    const decimalPlaces = 2;
    if (inputType.toLowerCase() != 'float') {
      const invalidCharacters = ['e', '-', '+', '.'];
      if ((inputValue.length >= maxLength && event.key !== 'Backspace') || invalidCharacters.includes(event.key)) {
        event.preventDefault();
      }
    } else {
      const invalidCharacters = ['e', '-', '+']
      const dotIndex = inputValue.indexOf('.');
      if (dotIndex !== -1 && inputValue.substring(dotIndex + 1).length >= decimalPlaces && event.key !== 'Backspace') {
        event.preventDefault();
      } else {
        if ((inputValue.length >= maxLength && event.key !== 'Backspace') || invalidCharacters.includes(event.key)) {
          event.preventDefault();
        }
      }
    }
  }
  
  checkExpiry(ledger) {
    ledger.isNeverExpiry = !ledger.isNeverExpiry;
    ledger.expiryDays = null;
  }

  

}
